import { render, staticRenderFns } from "./ListGroupsTable.vue?vue&type=template&id=e7be29fe&scoped=true&"
import script from "./ListGroupsTable.vue?vue&type=script&lang=js&"
export * from "./ListGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./ListGroupsTable.vue?vue&type=style&index=0&id=e7be29fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7be29fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDataTable,VRow})
